import Vue from 'vue'
import Router from 'vue-router'


import Login from '../pages/login/login.vue'
import ChoiceStore from '../pages/choiceStore/choiceStore.vue'
import resetPassword from '../pages/resetPassword/resetPassword.vue'
import Index from '../pages/index/index.vue'

import Home from '../components/home/home.vue'
import Stock_Check from '../components/stock/check/index.vue'
// import Stock_index from '../components/stock/check/check.vue'
// import Stock_Check_recode from '../components/stock/check/checkrecord.vue'
import Stock_Outer from '../components/stock/outer/outer.vue'
import Stock_Inner from '../components/stock/inner/inner.vue'
import Stock_Record from '../components/stock/record/record.vue'

import Bar_Check from '../components/bar/check/index.vue'
import Bar_Outer from '../components/bar/outer/outer.vue'
import Bar_Inner from '../components/bar/inner/inner.vue'
import Bar_Record from '../components/bar/record/record.vue'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '*',
            redirect: '/Index'
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/ChoiceStore',
            name: 'ChoiceStore',
            component: ChoiceStore
        },
        {
            path: '/resetPassword',
            name: 'resetPassword',
            component: resetPassword
        },
        {
            path: '/Index',
            name: 'Index',
            component: Index,
            redirect: '/Home',
            children:[
                {
                    path: '/Home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/Stock_Check/:type',
                    name: 'Stock_Check',
                    component: Stock_Check
                },
                {
                    path: '/Stock_Check',
                    name: 'Stock_Check',
                    component: Stock_Check
                },
                {
                    path: '/Stock_Outer',
                    name: 'Stock_Outer',
                    component: Stock_Outer
                },
                {
                    path: '/Stock_Inner',
                    name: 'Stock_Inner',
                    component: Stock_Inner
                },
                {
                    path: '/Stock_Record',
                    name: 'Stock_Record',
                    component: Stock_Record
                },
                {
                    path: '/Bar_Check',
                    name: 'Bar_Check',
                    component: Bar_Check
                },{
                    path: '/Bar_Check/:type',
                    name: 'Bar_Check',
                    component: Bar_Check
                },
                {
                    path: '/Bar_Outer',
                    name: 'Bar_Outer',
                    component: Bar_Outer
                },
                {
                    path: '/Bar_Inner',
                    name: 'Bar_Inner',
                    component: Bar_Inner
                },
                {
                    path: '/Bar_Record',
                    name: 'Bar_Record',
                    component: Bar_Record
                },
            ]
        },
        
        
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js